export interface CalculatePercentageParams {
  count: number;
  totalReviewsCount: number;
}

function calculatePercentage(props: CalculatePercentageParams) {
  const { count, totalReviewsCount } = props;

  const percentage = Math.round((count / totalReviewsCount) * 100);

  return percentage;
}

export default calculatePercentage;
